/*@flow*/

const geojson = {
  type: 'Polygon',
  coordinates: [
    [
      [-73.979091, 40.693676],
      [-73.978537, 40.689863],
      [-73.978115, 40.686739],
      [-73.979786, 40.686535],
      [-73.9819, 40.68731],
      [-73.981485, 40.687919],
      [-73.989347, 40.69095],
      [-73.991568, 40.691518],
      [-73.990525, 40.693674],
      [-73.991394, 40.696441],
      [-73.984542, 40.696181],
      [-73.982992, 40.6961],
      [-73.981805, 40.696096],
      [-73.98079, 40.696523],
      [-73.980527, 40.69671],
      [-73.980314, 40.696711],
      [-73.980181, 40.695959],
      [-73.980217, 40.695942],
      [-73.980144, 40.695477],
      [-73.980107, 40.695206],
      [-73.980052, 40.69475],
      [-73.979997, 40.694604],
      [-73.979958, 40.694519],
      [-73.979799, 40.69438],
      [-73.979527, 40.694157],
      [-73.979286, 40.693958],
      [-73.979192, 40.693857],
      [-73.979091, 40.693676],
    ],
  ],
};

export default geojson;

export const studyArea = JSON.stringify(geojson);
